export const passwordCriteria = [
  {
    id: "length",
    text: "Characters must be between 8 and 15",
    test: (pw: string) => pw.length >= 8 && pw.length <= 15,
  },
  {
    id: "lowercase",
    text: "At least one lowercase letter (a–z)",
    test: (pw: string) => /[a-z]/.test(pw),
  },
  {
    id: "uppercase",
    text: "At least one uppercase letter (A–Z)",
    test: (pw: string) => /[A-Z]/.test(pw),
  },
  {
    id: "digit",
    text: "At least one digit (0–9)",
    test: (pw: string) => /\d/.test(pw),
  },
  {
    id: "specialChar",
    text: "At least one special character (!@#$...)",
    // Space must not count as a special character
    test: (pw: string) => /[^A-Za-z0-9\s]/.test(pw),
  },
  {
    id: "noSpaces",
    text: "Spaces are not allowed",
    test: (pw: string) => pw.length > 0 && !/\s/.test(pw),
  },
];

export const PASSWORD_POLICY_ERROR =
  "New Password must be 8–15 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character. Spaces are not allowed.";

/** Full password policy: 8–15 chars, upper, lower, digit, special, no spaces. */
export const PASSWORD_POLICY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])\S{8,15}$/;

export function meetsPasswordPolicy(password: string): boolean {
  return PASSWORD_POLICY_REGEX.test(password);
}
